import { Card, HSpacing, Loader, Tag, Text } from '@hh.ru/magritte-ui';
import { BoltOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import styles from './index.less';

const TrlKeys = {
    oneClickTag: 'employer.vacancyResponses.changeTopic.button.oneClick.tag',
};
interface SubstateItemProps {
    name: string;
    funnelStageId: number;
    quickTransferToStageEnabled: boolean;
    onClick: (quickTransferToStageEnabled: boolean, funnelStageId: number) => void;
}

const SubstateItem: TranslatedComponent<SubstateItemProps> = ({
    name,
    funnelStageId,
    quickTransferToStageEnabled,
    onClick,
    trls,
}) => {
    const { isLoading, funnelStageId: id } =
        useSelector((state) => state.candidatesList?.loadingChangeTopicState) || {};
    const showLoader = isLoading && id === funnelStageId;

    return (
        <Card
            onClick={() => onClick(quickTransferToStageEnabled, funnelStageId)}
            borderRadius={16}
            padding={12}
            paddingLeft={16}
            hoverStyle="secondary"
            stretched
        >
            <div className={styles.buttonWrapper}>
                {showLoader && (
                    <>
                        <Loader initial="primary" size={24} />
                        <HSpacing default={4} />
                    </>
                )}
                <Text style="primary" typography="label-2-regular">
                    {name}
                </Text>
                {quickTransferToStageEnabled && (
                    <>
                        <HSpacing default={showLoader ? 8 : 24} />
                        <Tag icon={BoltOutlinedSize16} style="special">
                            {trls[TrlKeys.oneClickTag]}
                        </Tag>
                    </>
                )}
            </div>
        </Card>
    );
};

export default translation(SubstateItem);
